export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14819.d4da350d.jpg";